module.exports = __webpack_public_path__ + "img/sentiment-analysis.8c5b8a37.png";